import { fetchWithoutToken } from '../utils/fetch';

export const getInfoUserMoodle = async (codeParam, institutionCode) => {
	const getCredentials = () => {
		switch (institutionCode) {
			case 'CMVC':
				return {
					client_id: process.env.REACT_APP_CLIENTID_CMVC_MOODLE,
					client_secret: process.env.REACT_APP_CLIENTSECRET_CMVC_MOODLE,
				};
			case 'GAPAT':
				return {
					client_id: process.env.REACT_APP_CLIENTID_GAPAT,
					client_secret: process.env.REACT_APP_CLIENTSECRET_GAPAT,
				};
			case 'AMHEALTH':
				return {
					client_id: process.env.REACT_APP_CLIENTID_AMHEALTH,
					client_secret: process.env.REACT_APP_CLIENTSECRET_AMHEALTH,
				};
			case 'MACKENZIE':
				return {
					client_id: process.env.REACT_APP_CLIENTID_MACKENZIE,
					client_secret: process.env.REACT_APP_CLIENTSECRET_MACKENZIE,
				};
			case 'FGU':
				return {
					client_id: process.env.REACT_APP_CLIENTID_FGU,
					client_secret: process.env.REACT_APP_CLIENTSECRET_FGU,
				};
			case 'ABC':
				return {
					client_id: process.env.REACT_APP_CLIENTID_ABC,
					client_secret: process.env.REACT_APP_CLIENTSECRET_ABC,
				};
			case 'UNAD':
				return {
					client_id: process.env.REACT_APP_CLIENTID_UNAD,
					client_secret: process.env.REACT_APP_CLIENTSECRET_UNAD,
				};
			case 'UNAD_2':
				return {
					client_id: process.env.REACT_APP_CLIENTID_UNAD_2,
					client_secret: process.env.REACT_APP_CLIENTSECRET_UNAD_2,
				};
			case 'SUMMA':
				return {
					client_id: process.env.REACT_APP_CLIENTID_SUMMA,
					client_secret: process.env.REACT_APP_CLIENTSECRET_SUMMA,
				};
			case 'AHIS':
				return {
					client_id: process.env.REACT_APP_CLIENTID_AHIS,
					client_secret: process.env.REACT_APP_CLIENTSECRET_AHIS,
				};
			case 'AHIS_2':
				return {
					client_id: process.env.REACT_APP_CLIENTID_AHIS_2,
					client_secret: process.env.REACT_APP_CLIENTSECRET_AHIS_2,
				};
			case 'SAU':
				return {
					client_id: process.env.REACT_APP_CLIENTID_SAU,
					client_secret: process.env.REACT_APP_CLIENTSECRET_SAU,
				};
			case 'ALEPH':
				return {
					client_id: process.env.REACT_APP_CLIENTID_ALEPH,
					client_secret: process.env.REACT_APP_CLIENTSECRET_ALEPH,
				};
			case 'IHU':
				return {
					client_id: process.env.REACT_APP_CLIENTID_IHU,
					client_secret: process.env.REACT_APP_CLIENTSECRET_IHU,
				};
			case 'AES':
				return {
					client_id: process.env.REACT_APP_CLIENTID_AES_MOODLE,
					client_secret: process.env.REACT_APP_CLIENTSECRET_AES_MOODLE,
				};
			case 'IBECAM':
				return {
					client_id: process.env.REACT_APP_CLIENTID_IBECAM_MOODLE,
					client_secret: process.env.REACT_APP_CLIENTSECRET_IBECAM_MOODLE,
				};
			case 'BIRCHU':
				return {
					client_id: process.env.REACT_APP_CLIENTID_BIRCHU_MOODLE,
					client_secret: process.env.REACT_APP_CLIENTSECRET_BIRCHU_MOODLE,
				};
			case 'IUM':
				return {
					client_id: process.env.REACT_APP_CLIENTID_IUM_MOODLE,
					client_secret: process.env.REACT_APP_CLIENTSECRET_IUM_MOODLE,
				};
			case 'MIAMINSTITUTE':
				return {
					client_id: process.env.REACT_APP_CLIENTID_MIAMINSTITUTE_MOODLE,
					client_secret: process.env.REACT_APP_CLIENTSECRET_MIAMINSTITUTE_MOODLE,
				};
			case 'NEXTL':
				return {
					client_id: process.env.REACT_APP_CLIENTID_NEXTL_MOODLE,
					client_secret: process.env.REACT_APP_CLIENTSECRET_NEXTL_MOODLE,
				};
			default:
				return {
					client_id: process.env.REACT_APP_CLIENTID_CMVC_MOODLE,
					client_secret: process.env.REACT_APP_CLIENTSECRET_CMVC_MOODLE,
				};
		}
	};

	try {
		const res = await fetchWithoutToken.post(
			`/institutions/${institutionCode}/lms-auth`,
			{
				client_id: getCredentials().client_id,
				client_secret: getCredentials().client_secret,
				code: codeParam,
			},
			{
				headers: {
					Authorization: `Bearer ${localStorage.token}`,
				},
			}
		);
		return res;
	} catch (error) {
		console.error(
			'Your authorization token has expired or is incorrect.',
			error
		);
		return null;
	}
};
